import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RequestService, StoreService } from '../../shared/services';
import { Observable } from 'rxjs';

// Interface for components that need CanDeactivate protection
export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class AuthGuard implements CanActivate, CanDeactivate<CanComponentDeactivate> {
    constructor(
        private router: Router,
        private storeService: StoreService,
        private requestService: RequestService
    ) { }

    // ✅ Authentication logic (unchanged)
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (localStorage.getItem('currentUser')) {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            this.requestService.currentUser = currentUser;
            this.requestService.currentUserSubject.next(currentUser);
            this.requestService.authenticatedUser.next(true);
            if (this.legitUser(currentUser)) {
                return true;
            }
        }
        this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }

    // ✅ Prevent navigation if there are unsaved changes
    canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
        return component.canDeactivate ? component.canDeactivate() : true;
    }

    // ✅ Validate user token (unchanged)
    private legitUser(user): boolean {
        return user.hasOwnProperty('token');
    }
}
